
import { gsap } from "gsap"
import barba from '@barba/core'
import shuffle from 'lodash/shuffle'
const $ = require('jquery')

const barbaTransitionDuration = 0.9

const loader = document.querySelector('.loader')
const loaderZampa = document.querySelector('.loader__zampa')

const containerFadeOut = function(container) {
  return gsap.to(container, {
    duration: barbaTransitionDuration,
    opacity: 0
  })
}
const containerFadeIn = function(container) {
  return gsap.fromTo(container,
    {
      opacity: 0
    },
    {
      duration: barbaTransitionDuration,
      opacity: 1
    }
  )
}

const getPoisArr = function() {
  /*
  const poisTotal = 12;
  const matrixMax = 9
  const matrixRows = 4
  const matrixCols = 4
  let matrix = []
  for (let i = 0; i < poisTotal; i++) {
    let x = (i % matrixCols) / matrixCols * matrixMax + 0.5
    const rowIndex = Math.floor(i / matrixRows)
    let y = rowIndex / matrixRows * matrixMax + 1.5
    if (rowIndex === 1) {
      x = x + 1
    }
    matrix.push({ x: x, y: y })
  }
  let poisArr = []
  for (let i = 0; i < matrix.length; i++) {
    const size = (Math.floor(Math.random() * 5)) + 9
    const y = 100 + (matrix[i].y + Math.random()) * 10
    const x = (matrix[i].x + Math.random()) * 10
    poisArr.push({ x: x, y: y, size: size })
  }
  */
  let poisArr = [
    {x: 65.94768124477355, y: 104.67614716070686, size: 9},
    {x: 10.886075775381599, y: 124.43238505701265, size: 13},
    {x: 36.34503105778117, y: 116.11482648057505, size: 11},
    {x: 53.58017428352411, y: 123.28029917953494, size: 11},
    {x: 76.94768124477355, y: 122.67614716070686, size: 10},
    {x: 24.26301129134462, y: 139.7537580498723, size: 13},
    {x: 42.54886463587237, y: 145.57328014513703, size: 10},
    {x: 64.37474893238077, y: 144.60495192890562, size: 11},
    {x: 83.84623708102725, y: 139.96504641255143, size: 12},
    {x: 12.49529909731594, y: 169.80040266496223, size: 11},
    {x: 32.054172296827808, y: 175.13299776329686, size: 13},
    {x: 54.33117202530096, y: 161.24231607468104, size: 9},
    {x: 75.37897773269053, y: 165.11722950257135, size: 13}
  ]

  return shuffle(poisArr)
}

let loaderTl = null
const loaderIn = function(container) {
  if (loaderTl) {
    loaderTl.kill()
  }

  const $loader = $(loader)
  const poisArr = getPoisArr()
  const poisDurationTotal = 0.7
  const poisDelayOffset = 0.1

  $loader.find('.pois').remove()
  for (let i = 0; i < poisArr.length; i++) {
    const item = poisArr[i]
    $loader.append('<div class="pois" style="top: ' + item.y + 'vh; left: ' + item.x + 'vw; width: ' + item.size + 'vw; height: ' + item.size + 'vw;"></div>')
  }

  loaderTl = gsap.timeline({delay: barbaTransitionDuration + poisDelayOffset})
  const poisDuration = poisDurationTotal / poisArr.length
  $loader.find('.pois').each((index, layer) => {
    loaderTl.fromTo(layer, {scaleX: 0, scaleY: 0}, {autoAlpha: 1, scaleX: 1, scaleY: 1, duration: poisDuration, ease: 'power2'})
  })

  const transitionTl = gsap.timeline()

  transitionTl.fromTo(loader,
    {
      rotation: 10,
      //scaleX: 0,
      //xPercent: -5
      xPercent: -120
    },
    {
      duration: barbaTransitionDuration,
      //xPercent: 0,
      //scaleX: 1,
      xPercent: 0,
      rotation: 0,
      ease: 'power4.inOut',
      transformOrigin: 'left center'
    }
  )

  transitionTl.fromTo(loaderZampa,
    {
      rotation: 20,
      xPercent: -30
    },
    {
      duration: barbaTransitionDuration,
      rotation: 70,
      xPercent: 10,
      ease: 'power4.inOut',
      transformOrigin: 'left center',
      autoAlpha: 1
    },
    0
  )
  // https://greensock.com/docs/v3/GSAP/Timeline/totalDuration()
  transitionTl.totalDuration(barbaTransitionDuration + poisDurationTotal)
  return transitionTl
}

const loaderOut = function(container) {
  const transitionTl = gsap.timeline()

  transitionTl.to(loader, {
    duration: barbaTransitionDuration,
    //scaleX: 0,
    //xPercent: 5,
    xPercent: -120, //110
    rotation: 10, //-10
    transformOrigin: 'left center', //'right center',
    ease: 'power4.inOut'
  })

  transitionTl.to(loaderZampa, {
    duration: barbaTransitionDuration,
    rotation: 20,
    xPercent: -30,
    ease: 'power4.inOut'
  }, 0)

  return transitionTl
}

export const initLoader = function() {
  gsap.set(loader, {
    //scaleX: 0,
    rotation: 10,
    //xPercent: -5,
    yPercent: -50,
    xPercent: -110,
    transformOrigin: 'left center',
    autoAlpha: 1
  })
  //loaderIn()
  //loaderOut()
}

// https://barba.js.org/docs/advanced/hooks/
// https://barba.js.org/docs/advanced/views/
// https://barba.js.org/docs/userguide/syntax/
// https://barba.js.org/docs/getstarted/lifecycle/
// https://barba.js.org/docs/advanced/strategies/#prevent
// https://github.com/barbajs/barba/issues/526
let scrollModeHorizontalActive = null
let htmlClass = ''
let bodyClass = ''

let pageViewInit = null
let pageViewDestroy = null
const PageView = {
  namespace: 'page',
  // https://barba.js.org/docs/userguide/syntax/#lt-view-gt-object
  beforeEnter: function(data) {
    // using jsTransition, data.current.container and data.next.container in barba-wrapper
    // console.log('before-enter ' + $('#barba-wrapper').children().length)

    window.app.$html.removeClass('navigation-panel--open');
    window.app.$html.removeClass('scroll-lock');

    // barba.history.scrollRestoration set to 'manual';
    window.scrollTo(0, 0)
    // $window.scrollTop(0); // document.body.scrollTop = 0;

    /*
    * Hscroll
    */
    if (htmlClass) {
      window.app.$html.removeClass(htmlClass)
    }

    bodyClass = $(data.next.container).attr('data-bodyclass')
    window.app.$body.attr('class', bodyClass)
    //$(data.next.container).addClass(bodyClass)
    const hscroll = (bodyClass.indexOf('body--horizontal') > -1)

    if (hscroll) {
      if (!scrollModeHorizontalActive) {
        scrollConverter.activate(function (offset) {
          // console.log(offset); // Logs the current horizontal scroll offset
        })
      }
      // scrollConverter.enable(this.$el)
    } else {
      if (scrollModeHorizontalActive) {
        scrollConverter.deactivate()
        // scrollConverter.disable(this.$el)
      }
    }
    scrollModeHorizontalActive = hscroll
    htmlClass = (hscroll) ? 'html--horizontal' : 'html--vertical'
    window.app.$html.addClass(htmlClass)
  },
  // https://barba.js.org/docs/userguide/syntax/#Hooks
  afterEnter: function(data) {
    // using jsTransition, data.current.container and data.next.container in barba-wrapper
    // console.log('after-enter ' + $('#barba-wrapper').children().length)

    // required whether using jsTransition
    setTimeout(()=>{
      // data.next.container in barba-wrapper only
      // console.log('after-enter--timeout ' + $('#barba-wrapper').children().length)
      pageViewInit(data.next.container)
      if(typeof window.trackPageView === 'function') {
        window.trackPageView(location.pathname, document.title);
      }
    }, 10)
  },
  beforeLeave: function(data) {
    // data.current.container in barba-wrapper
    // console.log('before-leave ' + $('#barba-wrapper').children().length)

    //pageDestroy(data.current.container)
    setTimeout(() => {

      // gsap scrollTrigger fix! Scroll to o before new page is loaded
      window.scrollTo(0, 0)

      pageViewDestroy(data.current.container)
    }, ((barbaTransitionDuration * 1000) - 40))
  }
}

export const initBarba = function(pageInit, pageDestroy) {
  pageViewInit = pageInit
  pageViewDestroy = pageDestroy

  // https://barba.js.org/docs/advanced/hooks/
  // do something before the transition starts
  barba.hooks.before(() => {
      window.app.$html.addClass('is-transitioning')
  })
  // do something after the transition finishes
  barba.hooks.after(() => {
      window.app.$html.removeClass('is-transitioning')
  })
  barba.hooks.enter((data) => {
      window.scrollTo(0, 0)
  })
  //barba.use(barbaCss)

  barba.init({
    //debug: true,

    views: [ PageView ],

    // https://barba.js.org/docs/plugins/css/
    // https://barba.js.org/docs/plugins/css/#Transition-hooks
    // https://barba.js.org/docs/advanced/transitions/
    transitions: [{
      name: 'loader-transition',
      // sync true requires a rework on pageInit / pageDestroy logic
      sync: false,
      async leave(data) {
        await loaderIn(data.current.container)
      },
      enter(data) {
        loaderOut(data.next.container)
      },
      from: {
        custom: ({ trigger }) => {
          return trigger.classList && trigger.classList.contains('barba--loader-transition');
        },
      }
    },{
      name: 'fade-transition',
      // sync true requires a rework on pageInit / pageDestroy logic
      sync: false,
      async leave(data) {
        await containerFadeOut(data.current.container)
      },
      enter(data) {
        containerFadeIn(data.next.container)
      }
    }]
  });
}

export default {initLoader, initBarba}
